import { API_URL } from "./APIService";

export const ColoredStyleF = (s: string, row?: any) => {
  return { backgroundColor: row["rgb"] };
};

export const ReduceDisplayF = (s: string, row?: any): JSX.Element => {
  const sWithoutHtml = s.replace(/(<([^>]+)>)/gi, "");
  return (
    <span>
      {sWithoutHtml.indexOf("$$") !== -1
        ? sWithoutHtml.substring(
            0,
            sWithoutHtml.indexOf("$$", sWithoutHtml.indexOf("$$") + 2) + 2,
          )
        : sWithoutHtml.substring(0, 50) +
          (sWithoutHtml.length > 50 ? "..." : "")}
    </span>
  );
};

// export const ReduceDisplayWithIndentF = (s: string, row?: any) => {
//   const sWithoutHtml = s.replace(/(<([^>]+)>)/gi, "");
//   let indent = "";
//   if (row["order_task"].includes(".")) {
//     indent = " - "; // for subtasks
//   }
//   return (
//     indent +
//     sWithoutHtml.substring(0, 50) +
//     (sWithoutHtml.length > 50 ? "..." : "")
//   );
// };

export const DisplayWithPicture = (s: string, row?: any) => {
  return row["question_image"]
    ? "<img src='" + API_URL + "image" + row["question_image"] + "'><br>" + s
    : s;
};

export const rowsPerPageOptions = [
  {
    value: 1000000,
    label: "Все",
  },
];

export enum RowsPerPageEnum {
  ALL = 1000000,
}

export const MIN_MOBILE_WIDTH = 600;
export const modalPopupStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
};

export const modalPopupStyleMobile = {
  // position: "absolute",
  top: "10%",
  left: "10%",
  // transform: "translate(-50%, -50%)",
  // width: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 1,
};
